import React from 'react';

import {
    Box,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography
} from '@mui/material';

import { Link as RouterLink, useLocation } from 'react-router-dom';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';

import StreamIcon from '@mui/icons-material/StreamRounded';
import CreatorIcon from '@mui/icons-material/MovieCreationRounded';
import UserIcon from '@mui/icons-material/VerifiedUserRounded';
import PaymentIcon from '@mui/icons-material/PaymentRounded';
import { ExitToApp } from '@mui/icons-material';

import { useCookies } from 'react-cookie';

import { AppBar, Drawer, DrawerHeader } from '../../components/CustomDrawer';
import Logo from '../../assets/images/Nairolive_logo@4x1.webp';

const DashboardNavigationDrawer = ({ children }) => {
    const location = useLocation();
    const [cookies, setCookie, removeCookie] = useCookies(['access']);

    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);

    const resetSelections = () => {
        setSelectedIndex(0);
    };

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleLogout = () => {
        removeCookie('access');
        window.location.reload();
    };

    const DrawerNavButton = ({ icon, title, route, index, selected, onClick = null }) => {
        return (
            <ListItem key={index} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                    onClick={onClick}
                    component={RouterLink}
                    selected={location.pathname === route}
                    to={route}
                    sx={{
                        maxHeight: 35,
                        justifyContent: open ? 'initial' : 'center',
                        px: 2.5,
                        m: 1,
                        borderRadius: 2
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto' }}>{icon}</ListItemIcon>
                    <ListItemText
                        primary={title}
                        sx={{ opacity: open ? 1 : 0 }}
                        primaryTypographyProps={{
                            variant: 'subtitle1'
                        }}
                    />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <AppBar position="fixed" open={open} elevation={0}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{
                            marginRight: 5,
                            ...(open && {
                                display: 'none'
                            })
                        }}
                    >
                        <MenuRoundedIcon />
                    </IconButton>
                    <Typography
                        variant="h3"
                        component={RouterLink}
                        to="/"
                        underline="none"
                        color="white"
                        fontSize={15}
                        sx={{ flexGrow: 1, textDecoration: 'none' }}
                    >
                        NairoTV Admin
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open}>
                <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}>
                        {!open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>
                    <DrawerNavButton
                        title="Dashboard"
                        route="/"
                        icon={<SpaceDashboardRoundedIcon />}
                        index={0}
                        selected={selectedIndex === 0}
                        onClick={handleListItemClick}
                    />

                    <DrawerNavButton
                        title="Users"
                        route="/creators"
                        icon={<UserIcon />}
                        index={1}
                        onClick={handleListItemClick}
                    />

                    {/* <DrawerNavButton
                        title="User Manager"
                        route="/users"
                        icon={<UserIcon />}
                        index={2}
                        onClick={handleListItemClick}
                    /> */}

                    <DrawerNavButton
                        title="Withdrawals"
                        route="/withdrawals"
                        icon={<PaymentIcon />}
                        index={3}
                        onClick={handleListItemClick}
                    />

                    <DrawerNavButton
                        title="Video Manager"
                        route="/streams"
                        icon={<CreatorIcon />}
                        index={4}
                        onClick={handleListItemClick}
                    />
                </List>

                <Divider />

                <List>
                    <DrawerNavButton
                        noRoute
                        title="Logout"
                        route="/logout"
                        icon={<ExitToApp />}
                        index={4}
                        onClick={handleLogout}
                    />
                </List>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, px: { xs: 1, sm: 1 } , py: 1 }}>
                <DrawerHeader />
                {children}
            </Box>
        </Box>
    );
};

export default DashboardNavigationDrawer;
